import { useRef, useState } from "react";
import { API_BASE } from "@/lib/api";
import { Mic, Play, Pause } from "lucide-react";

/**
 * Compact voice player for a saved voice memo. Streams from /api/files/{path}
 * with cookie auth on same-origin — no signed URL needed.
 */
export default function VoicePlayer({ voicePath, transcript, testid = "voice-player" }) {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  if (!voicePath) return null;
  const toggle = () => {
    const a = audioRef.current;
    if (!a) return;
    if (playing) { a.pause(); } else { a.play().catch(() => {}); }
  };
  return (
    <div className="bi-surface p-3 flex items-center gap-3" data-testid={testid}>
      <button
        type="button"
        onClick={toggle}
        data-testid={`${testid}-toggle`}
        className="w-11 h-11 rounded-full bi-accent-btn flex items-center justify-center shrink-0"
      >
        {playing ? <Pause className="w-5 h-5" /> : <Play className="w-5 h-5 ml-0.5" />}
      </button>
      <div className="flex-1 min-w-0">
        <div className="text-[10px] uppercase tracking-[0.2em] font-heading text-white/50 inline-flex items-center gap-1"><Mic className="w-3 h-3" /> Voice memo</div>
        {transcript && (
          <div className="text-xs text-white/70 mt-0.5 line-clamp-2">&ldquo;{transcript}&rdquo;</div>
        )}
      </div>
      <audio
        ref={audioRef}
        src={`${API_BASE}/api/files/${voicePath}`}
        preload="none"
        onPlay={() => setPlaying(true)}
        onPause={() => setPlaying(false)}
        onEnded={() => setPlaying(false)}
      />
    </div>
  );
}
